export default {
    /**
     * @param { String } actionType
     * @param { Any } payload
     * @returns { import('@/typedefs/indexedDatabaseStoredAction').indexedDatabaseStoredAction }
     */
    formatActionToBeStored: ( actionType, payload ) => ( {
        type: actionType,
        timestamp: ( new Date() ).getTime(),
        payload,
    } ),
};
